const TaxAccountantTypes = () => {
  const types = [
    {
      type: '記帳代行型',
      icon: 'ri-file-list-3-line',
      description: '帳簿の記帳と決算申告のみを行う基本的なサービス',
      pros: ['料金が安い', '最低限の業務は完了'],
      cons: ['経営アドバイスがない', '節税提案が少ない', '受け身の対応'],
      suitable: '自分で経営判断ができる方',
    },
    {
      type: 'アドバイザー型',
      icon: 'ri-lightbulb-flash-line',
      title: 'おすすめ',
      description: '記帳代行に加えて、経営アドバイスや節税提案を積極的に行う',
      pros: ['経営改善の提案', '節税対策が充実', '定期的な面談', '資金繰り支援'],
      cons: ['料金がやや高い', '相性が重要'],
      suitable: '経営を成長させたい方',
    },
    {
      type: 'コンサルタント型',
      icon: 'ri-bar-chart-box-line',
      description: '税務だけでなく、経営全般のコンサルティングを提供',
      pros: ['経営計画の策定', '事業承継支援', '資金調達支援', 'M&Aアドバイス'],
      cons: ['料金が高い', '大企業向けが多い'],
      suitable: '本格的な経営支援が必要な方',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
            税理士の3つのタイプ
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            税理士のサービスタイプを理解して、あなたのニーズに合った税理士を選びましょう
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {types.map((type, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-6 sm:p-8 shadow-sm hover:shadow-xl transition-all hover:-translate-y-1 ${
                type.title ? 'border-2 border-red relative' : 'border border-gray-200'
              }`}
            >
              {type.title && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-red text-white px-4 sm:px-6 py-1 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap">
                  {type.title}
                </div>
              )}
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red/10 rounded-xl flex items-center justify-center mb-4 sm:mb-6 mx-auto">
                <i className={`${type.icon} text-2xl sm:text-3xl text-red`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 text-center">
                {type.type}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed text-center">
                {type.description}
              </p>

              <div className="mb-4 sm:mb-6">
                <h4 className="text-sm sm:text-base font-bold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  メリット
                </h4>
                <ul className="space-y-1.5 sm:space-y-2">
                  {type.pros.map((pro, idx) => (
                    <li key={idx} className="text-xs sm:text-sm text-gray-700 pl-6">
                      • {pro}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mb-4 sm:mb-6">
                <h4 className="text-sm sm:text-base font-bold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2">
                  <i className="ri-close-line text-red"></i>
                  デメリット
                </h4>
                <ul className="space-y-1.5 sm:space-y-2">
                  {type.cons.map((con, idx) => (
                    <li key={idx} className="text-xs sm:text-sm text-gray-700 pl-6">
                      • {con}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="pt-4 sm:pt-6 border-t border-gray-200">
                <p className="text-xs sm:text-sm text-gray-600 text-center">
                  <strong className="text-gray-900">こんな方におすすめ：</strong>
                  <br />
                  {type.suitable}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TaxAccountantTypes;
